import { ARRAY } from '../types';

/**
 * Converts a schema with a top-level type of array into a type object (single
 * schema) with a nested array of items.
 * @param {Object} schema - The schema that will be converted
 * @param {String} schema.type
 * @param {String} schema.items
 * @param {String} data - The data corresponding to the described by the schema
 */
const convertArrayToObjectSchema = (schema, data) => {
  let newSchema = {};
  if (schema.type !== ARRAY) {
    throw new Error('Ellington: Failed to convert schema');
  }

  const excludeKeys = ['type', 'items'];
  const topLevelKeys = Object.keys(schema).filter(
    k => !excludeKeys.includes(k.toLowerCase()),
  );

  topLevelKeys.forEach(k => {
    newSchema[k] = schema[k];
  });

  const items = schema.items;

  newSchema = {
    ...newSchema,
    type: 'object',
    propertiesOrder: ['data'],
    properties: {
      data: {
        type: 'array',
        items,
      },
    },
  };

  const newData = {
    data,
  };

  return [newSchema, newData];
};

export default convertArrayToObjectSchema;
